import axios from "axios";
import Config from "../config";
import { useLoginStore } from '../stores/login';
// const store = useLoginStore();

export default class ReportService {
    constructor() {
      this.loginStore = null;
    }

    store() {
      if(!this.loginStore) { this.loginStore = useLoginStore(); };
      return this.loginStore;
    }
    
    async fetchSnapshots(date=null, hour=null) {
        // let bodyTosend = {
        //     "username": this.store().getDecodedJWT.username
        // };

        // if (date !== null)
        //     bodyTosend.date = date.replace(/\//g, "-");

        // if (hour !== null)
        //     bodyTosend.hour = hour;

        const options = {
            headers: {
                ...Config.headers(this.store().getAccessToken), ...{},
            }
        }

        return axios
            .get(
                Config.url("listSnapshots") + (date!=null ? "/" + date.replace(/\//g, "-") : "" ) + (hour!=null ? "/" + hour : "" ),
                options
            )
            .then(res => res.data)
    }

    fetchPdfs() {
        const options = {
            headers: {
                ...Config.headers(this.store().getAccessToken), ...{},
            }
        }
        return axios
            .get(
                Config.url("listPdfs"),
                options
            )
            .then(res => res.data);
            
    }

    downloadPdf(uri) {
        axios.get(uri, {
            responseType: 'blob'
        })
            .then(response => {
                const contentType = response.headers['content-type'];
                // const filename = contentDisposition ? contentDisposition.split('filename=')[1] : 'downloaded-file.pdf';
                const filename = uri.replace(/^.*[\\\/]/, '').replace(/\?.*/, '');
                if (contentType === 'application/pdf') {
                    const blob = new Blob([response.data], { type: contentType });
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = filename;
                    console.log(link);
                    link.click();
                } else {
                    console.error('Invalid content type. Expected application/pdf.');
                }
            })
            .catch(error => {
                console.error('Error downloading file:', error);
            });
    }

    restoreSnapshot(name) {
        let bodyTosend = {
            "file_name": name,
        };
        const options = {
            headers: {
                ...Config.headers(this.store().getAccessToken), ...{},
            }
        };
        return axios
            .post(
                Config.url("deletePdf"),
                bodyTosend,
                options
            )
            .then(res => res.data);
    }

    async deleteSnapshot(node) {
        // const file_name = "snapshots/" + this.store().getDecodedJWT.username + "/" + node.parent.replace(/\//g, "-") + "/" + node.name;
        // let bodyTosend = {
        //     "file_name": file_name,
        // };
        const options = {
            headers: {
                ...Config.headers(this.store().getAccessToken), ...{},
            }
        };
        return axios
            .delete(
                Config.url("deleteSnapshot") + "/" + node.parent.replace(/\//g, "-") + "/" + node.name.replace(".json", ""),
                options
            )
            .then(res => res);
    }
}
